import moment from "moment";
import VueTimepicker from 'vue2-timepicker';
import VueTagsInput from '@johmun/vue-tags-input';
import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';

Vue.component('reports', {
    components: {
        VueTimepicker, VueTagsInput
    },

    props: ['clients'],

    data () {
        return {
            calendar: null,

            createScheduleForm: $.extend(true, new Form({
                data: {
                    client: '',
                    interval: '',
                    day_of_week: '',
                    day_of_month: '',
                    time: '',
                    recipient: '',
                    recipients: [
                        {
                            "text": "reports@thequadgroup.com",
                            "tiClasses": ["ti-valid"]
                        }
                    ]
                }
            }), {}),

            editScheduleForm: $.extend(true, new Form({
                data: {
                    client: '',
                    interval: '',
                    day_of_week: '',
                    day_of_month: '',
                    time: '',
                    recipient: '',
                    recipients: []
                }
            }), {}),

            reportId: null,

            lastDates: {},

            loading: true,

            deleting: false,

            deleteWorking: false
        };
    },

    mounted () {
        this.calendar = new Calendar(document.getElementById('calendar'), {
            plugins: [
                interactionPlugin,
                dayGridPlugin
            ],

            header: {
                left: 'prev,next today',
                center: 'title',
            },

            defaultView: 'dayGridMonth',

            navLinks: true,

            datesRender: (info) => {
                this.getReports(info.view.activeStart, info.view.activeEnd);
            },

            eventClick: this.editReport
        });

        this.calendar.render();

        $('#edit-report').on('hidden.bs.modal', () => {
            this.editScheduleForm.resetForm();
            this.editScheduleForm.resetAlert();
            this.editScheduleForm.data.recipients = [];
        });
    },

    methods: {
        createSchedule () {
            Http.post('/api/reports/create', this.createScheduleForm).then((response) => {
                this.createScheduleForm.resetForm();

                $('#schedule-report').modal('hide');

                this.getReports(this.lastDates.from, this.lastDates.to);
            });
        },

        getReports(from, to) {
            this.lastDates = {
                from,
                to
            };

            this.calendar.getEvents().forEach(event => {
                event.remove();
            });

            axios.get('/api/reports', {
                params: {
                    from: moment(from).format("YYYY-MM-DD"),
                    to: moment(to).format("YYYY-MM-DD")
                }
            }).then((response) => {
                for (let event of response.data) {
                    this.calendar.addEvent(event);
                }
            });
        },

        editReport (e) {
            $('#edit-report').modal('show');
            this.loading = true;

            this.reportId = e.event.id;

            axios.get('/api/reports/edit/' + e.event.id).then(response => {
                this.loading = false;

                this.editScheduleForm.data.client = response.data.client_id;
                this.editScheduleForm.data.interval = response.data.interval;
                this.editScheduleForm.data.time = response.data.time;

                if (['weekly', 'fortnightly'].indexOf(response.data.interval) !== -1) {
                    this.editScheduleForm.data.day_of_week = response.data.day;
                } else if (['monthly'].indexOf(response.data.interval) !== -1) {
                    this.editScheduleForm.data.day_of_month = response.data.day;
                }

                for (let recipient of response.data.recipients) {
                    this.editScheduleForm.data.recipients.push({
                        "text": recipient,
                        "tiClasses": ["ti-valid"]
                    });
                }
            });
        },

        updateReport() {
            Http.post('/api/reports/update/' + this.reportId, this.editScheduleForm).then((response) => {
                $('#edit-report').modal('hide');

                this.getReports(this.lastDates.from, this.lastDates.to);
            });
        },

        setupDelete () {
            this.deleting = true;
        },

        performDelete () {
            this.deleteWorking = true;

            axios.post('/api/reports/delete/' + this.reportId).then(response => {
                this.deleting = false;
                this.deleteWorking = false;

                $('#edit-report').modal('hide');

                this.getReports(this.lastDates.from, this.lastDates.to);
            });
        },

        cancelDelete () {
            this.deleting = false;
        }
    }
});